import { ShopperAgentTraceSchema } from "@redotech/redo-shopper-agent-common/trace";
import * as z from "zod";

export const getShopperAgentTrace = {
  name: "getShopperAgentTrace" as const,
  /** A pasted message id from either side of the conversation, or a draft id. */
  input: z.object({ id: z.string() }),
  output: ShopperAgentTraceSchema.nullable(),
};
